var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStamps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_19582",
    "data-name": "Grupo 19582",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.768,
    height: 81.73,
    viewBox: "0 0 81.768 81.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-ecommerce-badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M76.547,32.661l1.307-8.217a4.445,4.445,0,0,0-2.839-4.93l-7.731-2.988L64.334,8.832a4.445,4.445,0,0,0-4.893-2.839L51.224,7.3,44.8,2.072a4.482,4.482,0,0,0-5.677,0L32.661,7.3,24.444,5.994a4.445,4.445,0,0,0-4.93,2.839l-2.988,7.731L8.832,19.514a4.445,4.445,0,0,0-2.839,4.893L7.3,32.624,2.072,39.048a4.482,4.482,0,0,0,0,5.677L7.3,51.149,5.994,59.366a4.445,4.445,0,0,0,2.839,4.967l7.731,2.988,2.951,7.694a4.445,4.445,0,0,0,4.893,2.839l8.217-1.307,6.424,5.229a4.482,4.482,0,0,0,5.677,0l6.424-5.229,8.217,1.307a4.445,4.445,0,0,0,4.967-2.839l2.988-7.731L75.053,64.3A4.445,4.445,0,0,0,77.891,59.4l-1.307-8.217,5.229-6.424a4.482,4.482,0,0,0,0-5.677Z",
    transform: "translate(-1.059 -1.059)",
    fill: "#17dba1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-check-simple",
    transform: "translate(29.88 33.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M5.15,14.832l8.236,8.217L30.734,7.96",
    transform: "translate(-5.15 -7.96)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamps);
export default __webpack_public_path__ + "static/media/stamps.b6ac90e95f923bb6c5d45a4b69efb6ad.svg";
export { ForwardRef as ReactComponent };